import { FC, useContext, useState } from 'react';
import { match, useHistory } from 'react-router';
import styles from '../css/Login.module.scss';
import Header from './Header';
import AlertContext from './Alert';
import apiUrl from '../assets/apiUrl';
import {
  Avatar,
  Grid,
  Paper,
  TextField,
  Button,
  Typography,
  Link,
} from '@material-ui/core';
import { LockOpenOutlined } from '@material-ui/icons';

interface Props {
  match: match<{ token: string }>;
}

const ChangePassword: FC<Props> = ({ match }) => {
  const [password, setPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const history = useHistory();
  const { show } = useContext(AlertContext);
  const onSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const response = await fetch(`${apiUrl}/auth/change_password`, {
        method: 'POST',
        body: new URLSearchParams({
          token: match.params.token,
          password: password,
          revoke_all: 'true',
        }),
      });
      if (!response.ok) {
        throw response.statusText;
      }
      history.push('/');
    } catch (error: any) {
      show({ title: 'Change password error', body: error, type: 'error' });
    }
  };
  const paperStyle = {
    padding: 20,
    width: 280,
    margin: '20px auto',
  };
  return (
    <div className="homepage">
      <Header />
      <div className={styles.Login}>
        <Grid>
          <Paper elevation={10} style={paperStyle}>
            <Grid container spacing={0} direction="column" alignItems="center">
              <Avatar style={{ backgroundColor: '#f6690c' }}>
                <LockOpenOutlined />
              </Avatar>
              <h2>Change Password</h2>
            </Grid>
            <form onSubmit={onSubmit}>
              <TextField
                label="password"
                placeholder="enter your password"
                type="password"
                fullWidth
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <TextField
                label="repeat password"
                placeholder="repeat your password"
                type="password"
                fullWidth
                required
                value={repeatPassword}
                onChange={(e) => setRepeatPassword(e.target.value)}
              />
              <Button
                type="submit"
                color="primary"
                variant="contained"
                fullWidth
                style={{ marginTop: '16px' }}
              >
                Change Password
              </Button>
            </form>
            <Typography style={{ margin: '16px 0' }}>
              <Link href="/">Return to homepage</Link>
            </Typography>
          </Paper>
        </Grid>
      </div>
    </div>
  );
};

export default ChangePassword;
